import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LoadingState from '../../../components/dashboard/LoadingState';

/**
 * `/dashboard/leads/:uuid`: endereço do detalhe do lead para qualquer origem
 * (lista, kanban, jornada, link compartilhado). Enquanto a tela de detalhe não
 * existe (#814), abre a conversa do lead no app mobile.
 */
export default function LeadDetailRedirect() {
  const { uuid } = useParams();

  useEffect(() => {
    // Outro app (rotas do mobile): navegação completa, não do router.
    window.location.replace(`/mobile/leads/${uuid}`);
  }, [uuid]);

  return <LoadingState />;
}
